import { Component, OnInit } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";

@Component({
  selector: "app-datepicker-modal",
  templateUrl: "./datepicker-modal.page.html",
  styleUrls: ["./datepicker-modal.page.scss"],
})
export class DatepickerModalPage implements OnInit {
  date: string; // Use ISO string format
  year: number;
  month: number;
  day: number;

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams
  ) {}

  ngOnInit() {
    this.date = this.navParams.data.paramObject.date;

    if (this.date == null || new Date(this.date).getUTCFullYear() > 2100) {
      this.date = new Date().toISOString(); // Ensure ISO format
    }

    const dateObj = new Date(this.date);
    this.month = dateObj.getMonth() + 1;
    this.day = dateObj.getDate();
    this.year = dateObj.getFullYear();

    // Ensure the date is in ISO format for ion-datetime
    this.date = new Date(this.year, this.month - 1, this.day).toISOString();
  }

  onPickerChange(event: any) {
    this.date = event.detail.value; // Use event.detail.value for ion-datetime
    const dateObj = new Date(this.date);
    this.month = dateObj.getMonth() + 1;
    this.day = dateObj.getDate();
    this.year = dateObj.getFullYear();
  }

  onDateChange() {
    this.date = new Date(this.year, this.month - 1, this.day).toISOString(); // Ensure ISO format
  }

  async onCloseUpload() {
    const todayDate = new Date();
    const selectedDate = new Date(this.date);

    if (
      this.navParams.data.paramObject.canBackwardsSelected === false &&
      selectedDate < todayDate
    ) {
      alert("The date cannot be earlier than today.");
      // Reset to today's date
      this.date = todayDate.toISOString();
      const dateObj = new Date(this.date);
      this.month = dateObj.getMonth() + 1;
      this.day = dateObj.getDate();
      this.year = dateObj.getFullYear();
    } else {
      await this.modalCtrl.dismiss(this.date);
    }
  }
}
